import { useCheckPermission } from "commons/hooks/use-check-permission";
import { AccessDenied } from "pages/errors/access-denied";
import { ReactNode } from "react";

type PermissionProtectProps = {
  accessPermissions: string[];
  children: ReactNode;
};
export const PermissionProtect = ({
  children,
  accessPermissions,
}: PermissionProtectProps) => {
  const { allowAccess } = useCheckPermission(accessPermissions);
  return <>{allowAccess ? children : <AccessDenied></AccessDenied>}</>;
};

type PermissionProtectIndexProps = {
  accessPermissions: string[];
  children: (accessKey: string | null) => ReactNode;
};
export const PermissionProtectIndex = ({
  children,
  accessPermissions,
}: PermissionProtectIndexProps) => {
  const { allowAccess, accessKey } = useCheckPermission(accessPermissions);

  return (
    <>{allowAccess ? children(accessKey) : <AccessDenied></AccessDenied>}</>
  );
};
